import api from "@/utils/axios";

const AUTH_API_URL = `/auth`;

export default {
  namespaced: true,
  state: {
    user: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_AUTH(state) {
      state.user = null;
      state.error = null;
    },
  },
  actions: {
    async signIn({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(`${AUTH_API_URL}/signIn/`, payload);
        const token = response.data.token;
        if (token) {
          localStorage.setItem("session_token", token);
        }
        commit("SET_USER", response.data.user);
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.error || "Sign in failed");
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async tokenSignIn({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(`${AUTH_API_URL}/token/`, null, {
          successNotify: false,
          errorNotify: false,
        });
        commit("SET_USER", response.data.user);
        return response.data;
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Token sign in failed"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async signOut({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.post(`${AUTH_API_URL}/signOut/`, null, {
          errorNotify: false,
        });
      } catch (error) {
        // Optionally log error
      } finally {
        localStorage.removeItem("session_token");
        commit("CLEAR_AUTH");
        commit("SET_LOADING", false);
      }
    },

    async signOutEverywhere({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.post(`${AUTH_API_URL}/signOut/all/`, null, {
          errorNotify: false,
        });
      } catch (error) {
        // Optionally log error
      } finally {
        localStorage.removeItem("session_token");
        commit("CLEAR_AUTH");
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    authUser: (state) => state.user,
    authLoading: (state) => state.loading,
    authError: (state) => state.error,
  },
};
